export default "__VITE_ASSET__88411aec__"